module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-page-wrapper"
  }, [_c('div', {
    staticClass: "error-page-inner"
  }, [_c('h1', [_vm._v("404")]), _vm._v(" "), _c('h3', [_vm._v("Whoops! Something went wrong...")]), _vm._v(" "), _c('p', [_vm._v("We could not find what you were looking for.")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: _vm.$route.name
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-xs btn-primary"
  }, [_vm._v("\n                Refresh this page\n            ")])]), _vm._v("\n        |\n        "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'Index'
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-xs btn-primary"
  }, [_vm._v("\n                Go to \"home\"\n            ")])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-301a1469", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-301a1469"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/404.vue
// module id = 811
// module chunks = 0